<template>
  <v-alert
    v-if="items.length"
    :type="type"
    outlined
    dense
  >
    <v-row align="center">
      <v-col>
        {{ $t('payment.milestone.errorsDuringValidation') }}
        <li
          v-for="(error, index) in items.length > 3 && errorsAlertExpanded ? items : items.slice(0, items.length === 3 ? 3 : 2)"
          :key="index"
        >
          {{error}}
        </li>
        <li v-if="items.length > 3 && !errorsAlertExpanded">{{ $t('payment.milestone.more') }}</li>
      </v-col>
      <v-btn
        icon
        @click="errorsAlertExpanded = !errorsAlertExpanded"
        color="error"
        class="ma-1"
        v-if="items.length > 3"
      >
        <v-icon>{{ errorsAlertExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
      </v-btn>
    </v-row>
      </v-alert>
</template>

<script>
export default {
  name: 'ErrorsListAlert',
  props: {
    type: {
      type: String,
      default: 'error'
    },
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      errorsAlertExpanded: false
    }
  }
}
</script>
